/**
 * ElasticSearch Configuration Module
 *
 * Provides configuration for connecting to ElasticSearch backend.
 * Index names follow mustang pattern: {tenant}-production-{index}-{language}
 *
 * Reference: maple/backend/mustang/mustang/search/elastic/ads_index.py
 */

export const ES_CONFIG = {
  // Env vars exposed via next.config.js env block (same as Mustang)
  // IMPORTANT: Use read-only search credentials only!
  url: process.env.ELASTIC_SEARCH_API_URL || "",
  credentials: process.env.ELASTIC_SEARCH_API_SEARCH_CREDENTIALS || "",
  indices: {
    // Same as Mustang/Zameen
    ads: "zameen-production-ads-en",
    locations: "zameen-production-locations-en",
  },
  // Default request timeout in milliseconds
  timeout: 30000,
}

/**
 * Get the ads index name
 * @returns {string} The ads index name
 */
export const getAdsIndexName = () => ES_CONFIG.indices.ads

/**
 * Get the locations index name
 * @returns {string} The locations index name
 */
export const getLocationsIndexName = () => ES_CONFIG.indices.locations
